import React, { useState, useContext } from 'react';
import { useAuth } from '../contexts/AuthContext';

function StaffRegistration() {
  const { handleAPICall } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    role: '',
    specialization: '',
    contact: '',
    email: '',
    hireDate: '',
    date_of_birth: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const roles = [
    'midwife',
    'obstetrician',
    'nurse',
    'paediatrician',
    'it_support'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = 'Required';
    if (!formData.lastName.trim()) newErrors.lastName = 'Required';
    if (!formData.role) newErrors.role = 'Required';
    if (!formData.contact.trim()) newErrors.contact = 'Required';
    if (!formData.date_of_birth.trim()) newErrors.date_of_birth = 'Required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setIsSubmitting(true);
    try {
      const response = await handleAPICall({
        ...formData,
        apiType: 'staffRegistration'
      });
      if(response.data.success){
alert(response.data.message);
      }
      else{
        alert("Database Connection Error: Failed To Register User");
      }
      //console.log("Data From Backend = ", response.data);
    } catch (error) {
      alert('Failed To Register User, Check Your Internet Connection');
    }
    setIsSubmitting(false);
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded-3 shadow bg-white mt-5">
      <h2 className="mb-4 text-primary fw-bold">Staff Registration</h2>
      
      <div className="row mb-4 g-3">
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">First Name *</label>
            <input
              type="text"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 ${errors.firstName ? 'is-invalid' : ''}`}
            />
            {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Last Name *</label>
            <input
              type="text"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 ${errors.lastName ? 'is-invalid' : ''}`}
            />
            {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
          </div>
        </div>
      </div>

      <div className="row mb-4 g-3">
      <div className="col-md-4">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Date Of Birth</label>
            <input
              type="date"
              name="date_of_birth"
              value={formData.date_of_birth}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2"
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Role *</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              className={`form-select border-bottom border-light py-2 w-100 ${errors.role ? 'is-invalid' : ''}`}
            >
              <option value="">Select Role</option>
              {roles.map(role => (
                <option key={role} value={role}>
                  {role.replace('_', ' ').toUpperCase()}
                </option>
              ))}
            </select>
            {errors.role && <div className="invalid-feedback">{errors.role}</div>}
          </div>
        </div>
        <div className="col-md-4">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Specialization</label>
            <input
              type="text"
              name="specialization"
              value={formData.specialization}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2"
              disabled={formData.role === 'it_support'}
            />
          </div>
        </div>
      </div>

      <div className="row mb-4 g-3">
        <div className="col-md-4">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Phone *</label>
            <input
              type="text"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              className={`form-control border-bottom border-light py-2 ${errors.contact ? 'is-invalid' : ''}`}
            />
            {errors.contact && <div className="invalid-feedback">{errors.contact}</div>}
          </div>
        </div>
        <div className="col-md-4">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2"
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="mb-3">
            <label className="form-label fw-medium text-secondary">Hire Date</label>
            <input
              type="date"
              name="hireDate"
              value={formData.hireDate}
              onChange={handleChange}
              className="form-control border-bottom border-light py-2"
            />
          </div>
        </div>
      </div>

      <div className="d-grid mt-4">
        <button
          type="submit"
          className="btn btn-primary btn-lg fw-medium"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Registering...' : 'Register Staff'}
        </button>
      </div>
    </form>
  );
}

export default StaffRegistration;